/* tslint:disable */
/* eslint-disable */
/**
 * pricing API
 * Pricing service
 *
 * The version of the OpenAPI document: 38.848.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ApplicationContextClassLoaderParentDefinedPackagesInner } from './ApplicationContextClassLoaderParentDefinedPackagesInner';
import {
    ApplicationContextClassLoaderParentDefinedPackagesInnerFromJSON,
    ApplicationContextClassLoaderParentDefinedPackagesInnerFromJSONTyped,
    ApplicationContextClassLoaderParentDefinedPackagesInnerToJSON,
} from './ApplicationContextClassLoaderParentDefinedPackagesInner';
import type { ApplicationContextClassLoaderParentUnnamedModule } from './ApplicationContextClassLoaderParentUnnamedModule';
import {
    ApplicationContextClassLoaderParentUnnamedModuleFromJSON,
    ApplicationContextClassLoaderParentUnnamedModuleFromJSONTyped,
    ApplicationContextClassLoaderParentUnnamedModuleToJSON,
} from './ApplicationContextClassLoaderParentUnnamedModule';

/**
 * 
 * @export
 * @interface ApplicationContextClassLoaderParent
 */
export interface ApplicationContextClassLoaderParent {
    /**
     * 
     * @type {string}
     * @memberof ApplicationContextClassLoaderParent
     */
    name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationContextClassLoaderParent
     */
    registeredAsParallelCapable?: boolean;
    /**
     * 
     * @type {ApplicationContextClassLoaderParentUnnamedModule}
     * @memberof ApplicationContextClassLoaderParent
     */
    unnamedModule?: ApplicationContextClassLoaderParentUnnamedModule;
    /**
     * 
     * @type {Array<ApplicationContextClassLoaderParentDefinedPackagesInner>}
     * @memberof ApplicationContextClassLoaderParent
     */
    definedPackages?: Array<ApplicationContextClassLoaderParentDefinedPackagesInner>;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationContextClassLoaderParent
     */
    defaultAssertionStatus?: boolean;
}

/**
 * Check if a given object implements the ApplicationContextClassLoaderParent interface.
 */
export function instanceOfApplicationContextClassLoaderParent(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ApplicationContextClassLoaderParentFromJSON(json: any): ApplicationContextClassLoaderParent {
    return ApplicationContextClassLoaderParentFromJSONTyped(json, false);
}

export function ApplicationContextClassLoaderParentFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApplicationContextClassLoaderParent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'registeredAsParallelCapable': !exists(json, 'registeredAsParallelCapable') ? undefined : json['registeredAsParallelCapable'],
        'unnamedModule': !exists(json, 'unnamedModule') ? undefined : ApplicationContextClassLoaderParentUnnamedModuleFromJSON(json['unnamedModule']),
        'definedPackages': !exists(json, 'definedPackages') ? undefined : ((json['definedPackages'] as Array<any>).map(ApplicationContextClassLoaderParentDefinedPackagesInnerFromJSON)),
        'defaultAssertionStatus': !exists(json, 'defaultAssertionStatus') ? undefined : json['defaultAssertionStatus'],
    };
}

export function ApplicationContextClassLoaderParentToJSON(value?: ApplicationContextClassLoaderParent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'registeredAsParallelCapable': value.registeredAsParallelCapable,
        'unnamedModule': ApplicationContextClassLoaderParentUnnamedModuleToJSON(value.unnamedModule),
        'definedPackages': value.definedPackages === undefined ? undefined : ((value.definedPackages as Array<any>).map(ApplicationContextClassLoaderParentDefinedPackagesInnerToJSON)),
        'defaultAssertionStatus': value.defaultAssertionStatus,
    };
}

